import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { LOCALE_ID, Injectable, Inject, EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import { registerLocale, getNames } from 'i18n-iso-countries';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';

class I18nCountrySelectService {
    constructor(localeId, errorHandler) {
        this.localeId = localeId;
        this.errorHandler = errorHandler;
        this.localeIds = ['en'];
    }
    use(localeIds) {
        return __awaiter(this, void 0, void 0, function* () {
            this.localeIds = [...localeIds];
            yield Promise.all(this.localeIds.map((localeId) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const locale = yield import(`i18n-iso-countries/langs/${localeId}.json`);
                    registerLocale(locale.default);
                }
                catch (error) {
                    this.errorHandler.handleError(error);
                }
            })));
        });
    }
    loadCountries() {
        return Object.entries(getNames(this.getLocale()))
            .map(([key, value]) => [key, Array.isArray(value) ? value[0] : value])
            .sort((a, b) => a[1].localeCompare(b[1]))
            .map((country) => ({ display: country[1], value: country[0].toLowerCase() }));
    }
    getLocale() {
        let locale;
        if (this.localeId.length > 2) {
            // convert Locale from ISO 3166-2 to ISO 3166 alpha2
            locale = this.localeId.toLowerCase().slice(0, 2);
        }
        else {
            locale = this.localeId.toLowerCase();
        }
        // return locale only if loaded else first available
        if (this.localeIds.indexOf(locale) > -1) {
            return locale;
        }
        else {
            return this.localeIds[0];
        }
    }
}
I18nCountrySelectService.ɵfac = function I18nCountrySelectService_Factory(t) { return new (t || I18nCountrySelectService)(i0.ɵɵinject(LOCALE_ID), i0.ɵɵinject(i0.ErrorHandler)); };
I18nCountrySelectService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: I18nCountrySelectService, factory: I18nCountrySelectService.ɵfac, providedIn: 'root' });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(I18nCountrySelectService, [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [LOCALE_ID]
                    }] }, { type: i0.ErrorHandler }];
    }, null);
})();

/* eslint-disable @angular-eslint/component-selector */
function I18nCountrySelectComponent_option_3_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "option", 1);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const country_r1 = ctx.$implicit;
        i0.ɵɵproperty("ngValue", country_r1.value);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(country_r1.display);
    }
}
class I18nCountrySelectComponent {
    constructor(cdRef, el, renderer, service) {
        this.cdRef = cdRef;
        this.el = el;
        this.renderer = renderer;
        this.service = service;
        this.name = 'I18nCountrySelect';
        this.pleaseChoose = 'Please choose...';
        this.editable = true;
        this.mandatory = false;
        this.iso3166Alpha2Change = new EventEmitter();
        this.items = [];
        this.items = this.service.loadCountries();
        this.defaultLabel = this.pleaseChoose;
    }
    change(newValue) {
        this.iso3166Alpha2 = newValue;
        this.iso3166Alpha2Change.emit(newValue);
    }
    ngAfterViewChecked() {
        const select = this.el.nativeElement.querySelector('select');
        if (this.iso3166Alpha2) {
            this.iso3166Alpha2 = this.iso3166Alpha2.toLowerCase();
        }
        if (this.mandatory) {
            this.renderer.setAttribute(select, 'required', '');
        }
        this.cdRef.detectChanges(); // avoid ExpressionChangedAfterItHasBeenCheckedError
    }
}
I18nCountrySelectComponent.ɵfac = function I18nCountrySelectComponent_Factory(t) { return new (t || I18nCountrySelectComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(I18nCountrySelectService)); };
I18nCountrySelectComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: I18nCountrySelectComponent, selectors: [["i18n-country-select"]], inputs: { name: "name", iso3166Alpha2: "iso3166Alpha2", size: "size", pleaseChoose: "pleaseChoose", editable: "editable", mandatory: "mandatory" }, outputs: { iso3166Alpha2Change: "iso3166Alpha2Change" }, decls: 4, vars: 9, consts: [[3, "name", "id", "ngModel", "disabled", "ngModelChange"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"]], template: function I18nCountrySelectComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "select", 0);
            i0.ɵɵlistener("ngModelChange", function I18nCountrySelectComponent_Template_select_ngModelChange_0_listener($event) { return ctx.change($event); });
            i0.ɵɵelementStart(1, "option", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, I18nCountrySelectComponent_option_3_Template, 2, 2, "option", 2);
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            i0.ɵɵclassMap("form-control" + (ctx.size ? " form-control-" + ctx.size : ""));
            i0.ɵɵproperty("name", ctx.name)("id", ctx.name)("ngModel", ctx.iso3166Alpha2)("disabled", !ctx.editable);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngValue", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(ctx.defaultLabel);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.items);
        }
    }, directives: [i2.SelectControlValueAccessor, i2.NgControlStatus, i2.NgModel, i2.NgSelectOption, i2.ɵNgSelectMultipleOption, i3.NgForOf], encapsulation: 2, changeDetection: 0 });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(I18nCountrySelectComponent, [{
            type: Component,
            args: [{
                    selector: 'i18n-country-select',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: `
    <select
      [name]="name"
      [id]="name"
      [class]="'form-control' + (size ? ' form-control-' + size : '')"
      [ngModel]="iso3166Alpha2"
      (ngModelChange)="change($event)"
      [disabled]="!editable"
    >
      <option [ngValue]="null">{{ defaultLabel }}</option>
      <option *ngFor="let country of items" [ngValue]="country.value">{{ country.display }}</option>
    </select>
  `
                }]
        }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: I18nCountrySelectService }]; }, { name: [{
                type: Input
            }], iso3166Alpha2: [{
                type: Input
            }], size: [{
                type: Input
            }], pleaseChoose: [{
                type: Input
            }], editable: [{
                type: Input
            }], mandatory: [{
                type: Input
            }], iso3166Alpha2Change: [{
                type: Output
            }] });
})();

function CountrySelectComponent_option_3_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "option", 1);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const country_r1 = ctx.$implicit;
        i0.ɵɵproperty("value", country_r1.value);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(country_r1.display);
    }
}
class CountrySelectComponent {
    constructor(service) {
        this.service = service;
        this.pleaseChoose = 'Please choose...';
        this.pleaseChooseEnabled = false;
        this.readonly = false;
        this.disabled = false;
        this.items = [];
        this.onChange = (value) => { };
        this.onTouched = () => { };
        this.touched = false;
        this.items = this.service.loadCountries();
    }
    set additionalItems(items) {
        this.items = [...items, ...this.items];
    }
    set onlyThisItems(items) {
        const filtered = this.items.filter((i) => items.lastIndexOf(i.value) > -1);
        this.items = filtered;
    }
    change($event) {
        this.value = $event;
        this.markAsTouched();
        this.onChange(this.value);
    }
    onAdd() {
        this.markAsTouched();
        if (!this.disabled) {
            this.onChange(this.value);
        }
    }
    onRemove() {
        this.markAsTouched();
        if (!this.disabled) {
            this.onChange(this.value);
        }
    }
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(onChange) {
        this.onChange = onChange;
    }
    registerOnTouched(onTouched) {
        this.onTouched = onTouched;
    }
    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
}
CountrySelectComponent.ɵfac = function CountrySelectComponent_Factory(t) { return new (t || CountrySelectComponent)(i0.ɵɵdirectiveInject(I18nCountrySelectService)); };
CountrySelectComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CountrySelectComponent, selectors: [["country-select"]], inputs: { name: "name", cssClass: "cssClass", value: "value", pleaseChoose: "pleaseChoose", pleaseChooseEnabled: "pleaseChooseEnabled", readonly: "readonly", disabled: "disabled", additionalItems: "additionalItems", onlyThisItems: "onlyThisItems" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: CountrySelectComponent,
            },
        ])], decls: 4, vars: 12, consts: [[3, "name", "id", "ngModel", "disabled", "ngModelChange"], [3, "value"], [3, "value", 4, "ngFor", "ngForOf"]], template: function CountrySelectComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "select", 0);
            i0.ɵɵlistener("ngModelChange", function CountrySelectComponent_Template_select_ngModelChange_0_listener($event) { return ctx.change($event); });
            i0.ɵɵelementStart(1, "option", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, CountrySelectComponent_option_3_Template, 2, 2, "option", 2);
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            i0.ɵɵclassMap(ctx.cssClass);
            i0.ɵɵproperty("name", ctx.name)("id", ctx.name)("ngModel", ctx.value)("disabled", ctx.disabled);
            i0.ɵɵattribute("readonly", ctx.readonly)("aria-readonly", ctx.readonly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("value", null);
            i0.ɵɵattribute("disabled", ctx.pleaseChooseEnabled ? null : true);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(ctx.pleaseChoose);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.items);
        }
    }, directives: [i2.SelectControlValueAccessor, i2.NgControlStatus, i2.NgModel, i2.NgSelectOption, i2.ɵNgSelectMultipleOption, i3.NgForOf], encapsulation: 2 });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CountrySelectComponent, [{
            type: Component,
            args: [{
                    // eslint-disable-next-line @angular-eslint/component-selector
                    selector: 'country-select',
                    template: ` <select
    [name]="name"
    [id]="name"
    [class]="cssClass"
    [ngModel]="value"
    (ngModelChange)="change($event)"
    [disabled]="disabled"
    [attr.readonly]="readonly"
    [attr.aria-readonly]="readonly"
  >
    <option [value]="null" [attr.disabled]="pleaseChooseEnabled ? null : true">{{ pleaseChoose }}</option>
    <option *ngFor="let country of items" [value]="country.value">{{ country.display }}</option>
  </select>`,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: CountrySelectComponent,
                        },
                    ],
                }]
        }], function () { return [{ type: I18nCountrySelectService }]; }, { name: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], value: [{
                type: Input
            }], pleaseChoose: [{
                type: Input
            }], pleaseChooseEnabled: [{
                type: Input
            }], readonly: [{
                type: Input
            }], disabled: [{
                type: Input
            }], additionalItems: [{
                type: Input
            }], onlyThisItems: [{
                type: Input
            }] });
})();

class I18nCountrySelectModule {
    static forRoot() {
        return {
            ngModule: I18nCountrySelectModule,
        };
    }
}
I18nCountrySelectModule.ɵfac = function I18nCountrySelectModule_Factory(t) { return new (t || I18nCountrySelectModule)(); };
I18nCountrySelectModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: I18nCountrySelectModule });
I18nCountrySelectModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, FormsModule]] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(I18nCountrySelectModule, [{
            type: NgModule,
            args: [{
                    declarations: [I18nCountrySelectComponent, CountrySelectComponent],
                    imports: [CommonModule, FormsModule],
                    providers: [],
                    exports: [I18nCountrySelectComponent, CountrySelectComponent],
                }]
        }], null, null);
})();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(I18nCountrySelectModule, { declarations: [I18nCountrySelectComponent, CountrySelectComponent], imports: [CommonModule, FormsModule], exports: [I18nCountrySelectComponent, CountrySelectComponent] }); })();

/*
 * Public API Surface of ngx-i18n-country-select
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CountrySelectComponent, I18nCountrySelectComponent, I18nCountrySelectModule, I18nCountrySelectService };
